export default {
  years: "Évek",
  countries: "Országok",
  leadership: "Vezetés",
  quality: "Minőség",
  solutions: "Megoldások",
  facilities: "Létesítmények",
  approvals: "Jóváhagyások",
  customers: "Ügyfelek",
  operations: "Műveletek",
  focused: "Összpontosított",
  vision: "Vízió",
};

